import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['snippet']

  // 根據snippetTarget來載入多少個snippet，將其轉成json給redactor來設定
  // ex: {
  //   'blue_line': {
  //     name: 'Blue Line',
  //     html: '<div>blue line</div>'
  //   }
  // }
  toJSON() {
    return [...this.snippetTargets].reduce(
      (rs, snippet) => {
        const { code, name } = snippet.dataset
        rs[code] = { name, html: snippet.innerHTML.trim() }

        return rs
      },
      {}
    )
  }
}
